import { swaggerSplitApi as api } from "../swaggerApi"

const createEventEditingApi = api.injectEndpoints({
	overrideExisting: true,
	endpoints: (builder) => ({
		editEvent: builder.mutation({
			query: (body) => ({
				url: `/api/v1/events/update`,
				method: "PATCH",
				body,
			}),
		}),
		deleteEvent: builder.mutation({
			query: ({orgId, eventId}) => ({
				url: `/api/v1/events/delete/${orgId}/${eventId}`,
				method: "DELETE",
			})
		})
	})
})

export const { useEditEventMutation, useDeleteEventMutation } = createEventEditingApi